(function () {
	const initAsideMenu = () => {
		const header = document.querySelector(".header-wrapper");
		const asideMenu = document.querySelector(".aside-menu");
		const openAsideMenuBtn = document.querySelector(
			".aside-menu__toggle--open-btn"
		);
		const closeMenuBtn = document.querySelector(
			".aside-menu__toggle--full-close-btn"
		);
		const closeAsideMenuBtn = document.querySelector(
			".aside-menu__toggle--close-btn"
		);
		const asideMenuOverlay = document.querySelector(".aside-menu__overlay");

		if (!asideMenu) return;

		const firstLevelItems = () =>
			document.querySelectorAll(".first_level_details");

		const secondLevelItems = () =>
			document.querySelectorAll(".second_level_details");

		if (header) header.preventHide = false;

		// =========================
		// OPEN MENU
		// =========================
		const openAsideMenu = (e) => {
			console.log("MAIN MENU CLICK (open aside menu)");
			e.preventDefault();

			if (header) header.preventHide = true;

			asideMenu.classList.add("aside-menu--open");
			asideMenuOverlay.classList.add("aside-menu__overlay--active");
			document.body.classList.add("overflow-hidden-aside");
		};

		// =========================
		// CLOSE MENU (FIXED WITH TRANSITION SAFETY)
		// =========================
		const closeAsideMenu = (e) => {
			const link = e?.target?.closest("a");

			// allow navigation without interference
			if (link) {
				console.log("LINK CLICK DETECTED:", link.href);

				setTimeout(() => {
					closeAsideMenu({ target: document.body });
				}, 0);

				return;
			}

			console.log("CLOSE MENU");

			asideMenu.classList.remove("aside-menu--open");
			asideMenuOverlay.classList.remove("aside-menu__overlay--active");
			document.body.classList.remove("overflow-hidden-aside");

			// wait for CSS transition (IMPORTANT FIX)
			setTimeout(() => {
				firstLevelItems().forEach((item) =>
					item.classList.remove("active")
				);
				secondLevelItems().forEach((item) =>
					item.classList.remove("active")
				);
			}, 300);

			if (header) header.preventHide = false;
		};

		// =========================
		// FIRST LEVEL CLICK (100% RELIABLE FIX)
		// =========================
		document.querySelectorAll(".menu-trigger").forEach((trigger) => {
			trigger.addEventListener("click", (e) => {
				console.log("FIRST MENU CLICK");

				e.preventDefault();
				e.stopPropagation();

				const item = trigger.closest(".first_level_details");

				if (!item) return;

				const isActive = item.classList.contains("active");

				firstLevelItems().forEach((el) => {
					if (el !== item) el.classList.remove("active");
				});

				secondLevelItems().forEach((el) =>
					el.classList.remove("active")
				);

				if (!isActive) {
					item.classList.add("active");
				} else {
					item.classList.remove("active");
				}
			});
		});

		// =========================
		// SECOND LEVEL CLICK
		// =========================
		document
			.querySelectorAll(".second_level_details .menu-trigger")
			.forEach((trigger) => {
				trigger.addEventListener("click", (e) => {
					console.log("SECOND MENU CLICK");

					e.preventDefault();
					e.stopPropagation();

					const subItem = trigger.closest(".second_level_details");
					const parentItem = trigger.closest(".first_level_details");

					if (!subItem || !parentItem) return;

					const isActive = subItem.classList.contains("active");

					parentItem
						.querySelectorAll(".second_level_details")
						.forEach((el) => el.classList.remove("active"));

					if (!isActive) {
						subItem.classList.add("active");
						parentItem.classList.add("active");
					}
				});
			});

		// =========================
		// BACK BUTTON
		// =========================
		document
			.querySelectorAll(".aside-menu__toggle--close-btn")
			.forEach((btn) => {
				btn.addEventListener("click", (e) => {
					console.log("BACK CLICK");

					const parentItem = btn.closest(
						".first_level_details, .second_level_details"
					);

					if (parentItem) parentItem.classList.remove("active");

					secondLevelItems().forEach((el) =>
						el.classList.remove("active")
					);
				});
			});

		// =========================
		// OPEN / CLOSE BUTTONS
		// =========================
		openAsideMenuBtn?.addEventListener("click", openAsideMenu);

		closeAsideMenuBtn?.addEventListener("click", (e) => {
			console.log("CLOSE BUTTON CLICK");
			e.stopPropagation();
			closeAsideMenu(e);
		});

		closeMenuBtn?.addEventListener("click", (e) => {
			console.log("FULL CLOSE CLICK");
			e.stopPropagation();
			closeAsideMenu(e);
		});

		asideMenuOverlay?.addEventListener("click", (e) => {
			console.log("OVERLAY CLICK");
			e.stopPropagation();
			closeAsideMenu(e);
		});

		// =========================
		// ESC KEY
		// =========================
		document.addEventListener("keydown", (e) => {
			if (e.code === "Escape") {
				console.log("ESC CLICK");
				closeAsideMenu(e);
			}
		});
	};

	document.addEventListener("shopify:section:load", initAsideMenu);
	document.addEventListener("shopify:section:unload", initAsideMenu);
	document.addEventListener("shopify:section:reorder", initAsideMenu);

	initAsideMenu();
})();